{
  "version": 1,
  "asset_id": "fb83a475-73b6-460d-87db-2884f8a4681f",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/fb83a475-73b6-460d-87db-2884f8a4681f/homosassa-blue-metal-roof-installation-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/fb83a475-73b6-460d-87db-2884f8a4681f/homosassa-blue-metal-roof-installation-768w.webp",
  "original_filename": "homosassa-blue-metal-roof-installation-768w.webp",
  "size": 51024,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
